import BlinkItLogo from 'assets/images/blinkitlogo.png';
import 'styles/BlinkItBanner.scss';

const BlinkItBanner = () => {
    return ( 
        <div id="blinkit-banner">
            <div className="heading">
                <img src={BlinkItLogo} alt="blinkit"></img>
            </div>
            <div className="subheading">
                Beauty Sale
            </div>
        </div> 
    );
}
 
export default BlinkItBanner;